// tslint:disable: max-classes-per-file
import { IContractAccountsCollection } from '@models/contract.class';
import { Action } from '@ngrx/store';

export enum CONTRACTSCOM_ACTION_TYPES {
  contracts_received = '[ContractsCom] Contracts received',
  contracts_not_received = '[ContractsCom] Contracts not received',
}

export class ContractsReceived implements Action {
  readonly type = CONTRACTSCOM_ACTION_TYPES.contracts_received;

  constructor(public payload: IContractAccountsCollection) {}
}

export class ContractsNotReceived implements Action {
  readonly type = CONTRACTSCOM_ACTION_TYPES.contracts_not_received;

  constructor(public payload: string) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type ContractsComActionsUnion = ContractsReceived | ContractsNotReceived;
